import { Paper, Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import AccordionSection from "../../shared/accordionSection";
import dayjs from "dayjs";
import { DeliveryData } from "@/app/interfaces/response/DQDeliveryOrderResponse";

const TITLE_DELIVERY = "Delivery Schedule";

const DeliverySchedule = ({ deliveryData }: { deliveryData: DeliveryData }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const dateObj = dayjs(deliveryData.deliveryDate);

  const formattedText = deliveryData.isTodaysDelivery
    ? `Today, ${dateObj.format("MMM D")}`
    : `${dateObj.format("dddd, MMM D")}`;

  const content = (
    <>
      <Box
        role="status"
        aria-label={`Delivered ${formattedText}`}
        sx={{
          display: "flex",
          alignItems: "center",
          borderRadius: 1,
          bgcolor: deliveryData.isFutureDelivery
            ? "#003b5c"
            : deliveryData.isTodaysDelivery
            ? "#4BB543"
            : "#808080",
          color: "white",
          px: 1,
        }}
      >
        <Typography component="span" sx={{ fontWeight: 700, mr: 0.5 }}>
          {deliveryData.isFutureDelivery ? "Scheduled" : "Delivered"}
        </Typography>
        <Typography component="span">{formattedText}</Typography>
      </Box>
    </>
  );

  return isMobile ? (
    <AccordionSection title={TITLE_DELIVERY}>{content}</AccordionSection>
  ) : (
    <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle1" fontWeight={600} mb={1}>
        {TITLE_DELIVERY}
      </Typography>
      {content}
    </Paper>
  );
};

export default DeliverySchedule;
